"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
function GoogleAnalyticsGtag(defaultTrackingId) {
    if (typeof window === 'undefined') {
        return function () { };
    }
    if (typeof window.gtag !== 'function') {
        /* tslint:disable: no-console */
        console.warn("\n    [@redux-beacon/google-analytics-gtag] Analytics are not being tracked, window.gtag \n    is not a function. Please include the Google Site Tag snippet:\n    https://developers.google.com/analytics/devguides/collection/gtagjs/\n    ");
        return function () { };
    }
    gtag('config', defaultTrackingId, { send_page_view: false });
    return function target(events) {
        var pageTracking = events.filter(function (event) { return event.type === 'page'; });
        var eventTracking = events.filter(function (event) { return event.type === 'event'; });
        pageTracking.forEach(function (event) {
            var type = event.type, trackingId = event.trackingId, params = __rest(event, ["type", "trackingId"]);
            var trackingIds = [defaultTrackingId];
            if (typeof trackingId === 'string') {
                trackingIds = [trackingId];
            }
            if (Array.isArray(trackingId) && trackingId.length > 0) {
                trackingIds = trackingId;
            }
            trackingIds.forEach(function (id) {
                gtag('config', id, params);
            });
        });
        eventTracking.forEach(function (event) {
            var type = event.type, action = event.action, params = __rest(event, ["type", "action"]);
            gtag('event', action, params);
        });
    };
}
exports.default = GoogleAnalyticsGtag;
